import { create, get, getAll, save } from "api/company";

export const getCompanies = () => (dispatch) =>
  dispatch({
    type: "COMPANIES_GET",
    payload: getAll(),
  });

export const getCompany = () => (dispatch) =>
  dispatch({
    type: "COMPANY_GET",
    payload: get(),
  });

export const saveCompany = (company) => (dispatch) =>
  dispatch({
    type: "COMPANY_SAVE",
    payload: save(company),
    meta: company,
  });

export const createCompany =
  (company, plan = "growth") =>
  (dispatch) =>
    dispatch({
      type: "COMPANY_CREATE",
      payload: create(company, plan),
    });
